/**
 * /library/wiki — redirect to the unified documents workspace.
 *
 * #223 — the documented Library IA exposes `/library/wiki` as a
 * deep link, but the actual wiki authoring surface lives inside
 * `/library/documents` (folder rail + article list + inline
 * editor). This route exists so deep links, docs, and bookmarks
 * land users on the right page instead of a 404.
 *
 * 2026-05-12 browser audit P1 #6 — B2 found this and the sibling
 * /library/folders "alias silently" because the previous Navigate
 * component rendered the Documents view but never rewrote the URL.
 * Switch to a `beforeLoad` redirect so the URL bar shows
 * /library/documents after navigation and the audit no longer
 * reports a layout-collapse defect.
 *
 * If wiki ever splits out into its own route component, replace
 * this redirect with the real component.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/library/wiki')({
  beforeLoad: ({ location }) => {
    const pathname = location.pathname.replace(/\/$/, '');
    if (pathname === '/library/wiki') {
      throw redirect({ to: '/library/documents', replace: true, code: 308 });
    }
  },
});
